<div class="container-fluid">
  <div class="card">
    <div class="card-header nocollapse">
      Question Repository
    </div>
    <div class="page-attributes p-1">
      <button type="button" class="btn btn-primary btn-action" (click)="openAddFolderModal(folderModel)"><i class="fa fa-folder-o"></i> Add Folder</button>
      <button type="button" class="btn btn-primary btn-action" (click)="redirectToSearch()"><i class="fa fa-search"></i> Search</button>
      <button type="button" class="btn btn-primary btn-action d-none" (click)="removeCacheData()"><i class="fa fa-trash"></i> Clear Cache</button>
    </div>
    <div id="messageContainer" class="card-header nocollapse bg-info col-md-12 msg-container" style="display:none;">
      <i class="fa fa-info-circle fa-lg mt-1" style="color: #326295;"></i>
      <span id="message"></span>
    </div>

    <!--<ng-template #template>
      <div class="modal-header">
        <h5 class="modal-title pull-left">Modal</h5>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        This is a modal.
      </div>
    </ng-template>-->

    <div>
      <!-- Using IsgGridComponent for consistent styling (ag-theme-balham) -->
      <isg-grid
        [rowData]="folderList"
        [columnDefs]="folder1columnDefs"
        [config]="folderGridConfig"
        (rowSelected)="onRowChecked($event)"
        (gridReady)="onQuestionGridReady($event)"
        (cellClicked)="onCellClicked($event, copyFolderModel, folderModel)">
      </isg-grid>
    </div>
    <!--<div class="row">
      <div class="col-6">
        <ag-grid-angular style="height: 400px;"
                         class="ag-theme-balham"
                         [enableSorting]="true"
                         [rowData]="folderList"
                         [columnDefs]="folder1columnDefs"
                         [enableFilter]="true"
                         (rowSelected)="onRowChecked($event)"
                         (gridReady)="onQuestionGridReady($event)"
                         rowSelection="multiple"
                         [pagination]="true"
                         [paginationPageSize]="10">
        </ag-grid-angular>
      </div>
      <div class="col-6">
        <ag-grid-angular style="height: 400px;"
                         class="ag-theme-balham"
                         [enableSorting]="true"
                         [rowData]="questionList"
                         [columnDefs]="columnDefs"
                         [enableFilter]="true"
                         (rowSelected)="onRowChecked($event)"
                         (gridReady)="onQuestionGridReady($event)"
                         rowSelection="multiple"
                         [pagination]="true"
                         [paginationPageSize]="10">
        </ag-grid-angular>
      </div>
    </div>-->
    <!--Folder Model-->
    <ng-template #folderModel let-modal>
      <div class="modal-header">
        <h5 class="modal-title">Create Folder</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="folderForm" #f="ngForm">
          <div class="row align-items-center">
            <label data-required class="form-control-label col-md-4" for="folderName">Folder Name</label>
            <div class="col-md-8">
              <input type="text" class="form-control" id="folderName" name="folderName" formControlName="folderName" placeholder="Folder Name" required>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-modal" (click)="CloseFolderForm(); modal.dismiss()"><i class="fa fa-times"></i> Close</button>
        <button type="button" class="btn btn-primary btn-modal" [disabled]="!folderForm.valid" (click)="saveFolder(); modal.close()"><i class="fa fa-save"></i> Save</button>
      </div>
    </ng-template>

    <!--Import Modal-->
    <ng-template #importModal let-modal>
      <div class="modal-header">
        <h5 class="modal-title">Import Question</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="questionForm">
          <div class="alert alert-info mb-3">
            <b>Folder:</b> {{currentSelectedFolderName}}
          </div>
          <div class="row align-items-center">
            <label data-required class="form-control-label col-md-4">Select File</label>
            <div class="col-md-8">
              <input type="file" class="form-control" (change)="incomingfile($event)" accept=".xlsx" placeholder="Upload file" required>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-modal" (click)="CloseQuestionForm(); modal.dismiss()"><i class="fa fa-times"></i> Close</button>
        <button type="button" class="btn btn-primary btn-modal" [disabled]="this.file==null" (click)="saveQuestion(); modal.close()"><i class="fa fa-upload"></i> Import</button>
      </div>
    </ng-template>

    <!--Delete Question Confirmation Modal-->
    <ng-template #deleteQuestionConfirmation let-modal>
      <div class="modal-header">
        <h5 class="modal-title">Delete Question/Folder Confirmation</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
      </div>
      <div class="modal-body">
        <p>Are you sure you want to delete the selected question/folder?</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-modal" (click)="modal.dismiss()"><i class="fa fa-times"></i> Close</button>
        <button type="button" class="btn btn-danger btn-modal" (click)="deleteQuestions(); modal.close()"><i class="fa fa-trash"></i> Delete</button>
      </div>
    </ng-template>

    <!--Export Questions Model-->
    <ng-template #exportQuestionsModel let-modal>
      <div class="modal-header">
        <h5 class="modal-title">Export Questions to Excel</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="exportQuestionsForm" #f="ngForm">
          <div class="alert alert-info mb-3">
            <b>Folder:</b> {{currentSelectedFolderName}}
          </div>
          <div>
            <label data-required class="form-control-label mb-2">Select the Question(s)</label>
            <!-- Using IsgGridComponent for consistent styling -->
            <isg-grid
              [rowData]="exportQuestionList"
              [columnDefs]="exportColumnDefs"
              [config]="exportGridConfig"
              [loading]="exportGridLoading"
              (rowSelected)="onExportQuestionRowChecked($event)"
              (gridReady)="onExportQuestionGridReady($event)">
            </isg-grid>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-modal" (click)="CloseExportQuestionsForm(); modal.dismiss()"><i class="fa fa-times"></i> Close</button>
        <button type="button" class="btn btn-primary btn-modal" [disabled]="this.questionsToExport.length<=0" (click)="exportQuestions(); modal.close()"><i class="fa fa-file-excel-o"></i> Export</button>
      </div>
    </ng-template>



    <div class="modal fade" id="copyQuestionModel" tabindex="-1" role="dialog" aria-labelledby="copyQuestionModel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Copy Question</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form [formGroup]="copyQuestionForm" #f="ngForm">
            <div class="modal-body  p-0">
              <div class="card-header nocollapse bg-info col-md-12 msg-container p-2">
                <b>Source Question : </b>{{currentSelectedQuestionName}}
              </div>

              <div class="form-group p-1">
                <table>
                  <tr>
                    <td>
                      <label for="question" class="form-control-label">New Question </label>
                    </td>
                    <td> <input type="text" name="question" id="question" formControlName="question" class="form-control-sm" /></td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal"><i class="fa fa-remove"></i> Close</button>
              <button type="button" class="btn btn-sm btn-primary" [disabled]="!copyQuestionForm.valid" data-dismiss="modal" (click)="CopyQuestion()"><i class="fa fa-copy"></i> Copy</button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!--Copy Folder Model-->
    <ng-template #copyFolderModel let-modal>
      <div class="modal-header">
        <h5 class="modal-title">Copy Folder</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
      </div>
      <form [formGroup]="copyFolderForm" #f="ngForm">
        <div class="modal-body">
          <div class="alert alert-info mb-3">
            <b>Source Folder:</b> {{currentSelectedFolderName}}
          </div>
          <div class="row align-items-center">
            <label for="folder" class="form-control-label col-md-4">New Folder Name</label>
            <div class="col-md-8">
              <input type="text" name="folder" id="folder" formControlName="folder" class="form-control" placeholder="Enter folder name" />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary btn-modal" (click)="modal.dismiss()"><i class="fa fa-times"></i> Close</button>
          <button type="button" class="btn btn-primary btn-modal" [disabled]="!copyFolderForm.valid" (click)="CopyFolder(); modal.close()"><i class="fa fa-copy"></i> Copy</button>
        </div>
      </form>
    </ng-template>

  </div>
</div>
